"use strict";

import React, {
  useCallback,
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { connect } from "react-redux";
import { turnoverRate } from "../../../store/actions";

const reportPropsData = (propsData) => {
  return {
    getData: (request) => {
      function extractRowsFromData(groupKeys, data) {
        if (groupKeys.length === 0) {
          return data.map(function (d) {
            return {
              group: !!(d.children && d.children.length),
              ...d
            }

          });
        }
        let key = groupKeys[0];
        for (let i = 0; i < data.length; i++) {
          if (data[i].label === key) {
            return extractRowsFromData(groupKeys.slice(1), data[i].children.slice());
          };
        };
      };
      return extractRowsFromData(request.groupKeys, propsData);
    }
  };
};

const createServerSideDataSource = (server) => {
  return {
    getRows: (params) => {
      let request = params.request;
      let response = server.getData(request);

      let doingInfinite = request.startRow != null && request.endRow != null;
      let result = doingInfinite
        ? {
          rowData: response.slice(request.startRow, request.endRow),
          rowCount: response.length,
        }
        : { rowData: response };

      setTimeout(function () {
        params.success(result);
      }, 200);
    }
  };
};

const TurnoverView = (props) => {
  const { isRefresh, refreshAgGrid } = props;
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const gridRef = useRef();
  const [columnDefs, setColumnDefs] = useState([]);
  const { startDate, endDate, report, monthly, detailed, monthNames } = props;


  useEffect(() => {
    let header = monthNames.map((month) => {
      if (monthly) {
        if (detailed) {
          return {
            headerName: month,
            children: [
              { field: `monthlyView.${month}.rate`, headerName: "Turnover Rate", minWidth: 150 },
              {
                field: `monthlyView.${month}.avgDailyHeadCount`,
                headerName: "Avg Daily Headcount",
                minWidth: 150,
              },
              {
                field: `monthlyView.${month}.allTerminated`,
                headerName: "Terminated",
                minWidth: 150,
              },
            ],
          }
        } else {
          return { field: `monthlyView.${month}.rate`, headerName: month };
        }
      } else return;
    }).filter(h => !!h);
    if (header.length) {
      setColumnDefs(header);
    } else {
      setColumnDefs([
        { field: "label", hide: "true" },
        { field: "rate", headerName: "Turnover Rate" },
        { field: "avgDailyHeadCount", headerName: "Avg Daily Headcount" },
        { field: "allTerminated", headerName: "Terminated" },
      ]);
    }
    if (isRefresh) {
      onGridReady(gridRef.current);
      refreshAgGrid(true);
    }
  }, [props]);

  const defaultColDef = useMemo(() => {
    return {
      width: 235,
      resizable: true,
      flex: 1,
      minWidth: 235,
    };
  }, []);
  const autoGroupColumnDef = useMemo(() => {
    return {
      field: "label",
      headerName: startDate + "-" + endDate,
    };
  }, []);
  const isServerSideGroupOpenByDefault = useCallback((params) => {
    // open first two levels by default
    return params.rowNode.level < 1;
  }, []);
  const isServerSideGroup = useCallback((dataItem) => {
    // indicate if node is a group
    return dataItem.children && dataItem.children.length;
  }, []);
  const getServerSideGroupKey = useCallback((dataItem) => {
    // specify which group key to use
    return dataItem.label;
  }, []);

  const onGridReady = async (params) => {
    let report = reportPropsData(props.report);
    let dataSource = createServerSideDataSource(report);
    params.api.setServerSideDatasource(dataSource);
  };

  return (
    <div style={containerStyle}>
      <div className="example-wrapper">
        <div style={gridStyle} className="ag-theme-alpine">
          <AgGridReact
            ref={gridRef}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            autoGroupColumnDef={autoGroupColumnDef}
            rowModelType={"serverSide"}
            treeData={true}
            animateRows={true}
            isServerSideGroupOpenByDefault={isServerSideGroupOpenByDefault}
            isServerSideGroup={isServerSideGroup}
            getServerSideGroupKey={getServerSideGroupKey}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducer, TurnoverReducer }) => {
  let { TURNOVER_RATE } = TurnoverReducer;
  return {
    UserReducer,
    TURNOVER_RATE,
  };
};

export default connect(mapStateToProps, {
  turnoverRate,
})(TurnoverView);
